/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React from "react";

interface ButtonProps {
  onButtonClick: (event: any) => void;
  name: string;
  className: string;
  id?: string;
}

/**
 * Reusable React component - Button.
 *
 * @namespace Button
 */
class Button extends React.Component<ButtonProps> {
  constructor(props: ButtonProps) {
    super(props);
    this.state = {
      submitted: false,
    };
  }

  /**
   * This method is used for handle button click
   * @param {any} event
   *
   */
  executeCallback = (event: any) => {
    if (this.props.onButtonClick) {
      this.props.onButtonClick(event);
    }
  };

  render() {
    const { name, className, id } = this.props;
    return (
      <div
        className={
          name === "Continue" || name === "Continuar"
            ? "btn-area continue-btn"
            : "btn-area"
        }
      >
        <button
          id={id}
          className={className || "app-btn"}
          onClick={this.executeCallback}
        >
          {name}
        </button>
      </div>
    );
  }
}

export default Button;
